/**
 * Renders a tooltip element
 */

import React from 'react';

const Tooltip = class Tooltip extends React.Component {
  render() {
    const { id, content, variation } = this.props;

    return (
      <div
        className={`tooltip${variation ? ` tooltip--${variation}` : ''}`}
      >
        <span
          className="tooltip__label"
          role="presentation"
          aria-hidden="true"
        >
          (?)
        </span>

        <div
          id={id}
          className="tooltip__body"
          role="tooltip"
        >
          {content}
        </div>
      </div>
    )
  }
}

export default Tooltip;
